import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Link} from 'react-router-dom';
import {baseUrl} from '../Univ.js';
function GrnList() {
    const [pharmviewData, setpharmviewData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const today = new Date();
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    useEffect(() => {
        if (startDate && endDate) {
            fetchpharmviewData();
        }
    }, [startDate, endDate]);
    function fetchpharmviewData() {
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        console.log('Fetching data...');
        axios.get(`${baseUrl}all-pharm-grn/?start_date=${startDateString}&end_date=${endDateString}&addedby=&mode=&status=1`)
            .then(response => {
                const transformedData = response.data.map(item => ({
                    ...item,
                    action: (
                        <Link target="_blank" to={`/grn-invoice/${item.grn_no}/`} className="btn btn-success">
                            View
                        </Link>
                    )
                }));
                setpharmviewData(transformedData);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {field: 'id', headerName: 'ID', width: 80},
        {field: 'grn_no', headerName: 'GRN No', width: 130},
        {field: 'product', headerName: 'Product', width: 290},
        {field: 'dist__name', headerName: 'Distributor', width: 220},
        {field: 'grnamount', headerName: 'Grn Amount', width: 90},
        {field: 'grn_date_date', headerName: 'Grn Date', width: 100},
        {field: 'invamount', headerName: 'Invoice Amount', width: 110},
        {field: 'inv_date', headerName: 'Invoice Date', width: 100},
        {
            field: 'action',
            headerName: 'Action',
            width: 80,
            renderCell: (params) => (
                <Link target="_blank" to={`/grn-invoice/${params.row.grn_no}/`} className="btn btn-success">
                    View
                </Link>
            ),
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'refill',
            headerName: 'Refill',
            width: 80,
            renderCell: (params) => (
                <Link target="_blank" to={`/re-grnentry/${params.row.grn_no}`} className="btn btn-primary">
                    Refill
                </Link>
            ),
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    GRN List
                </h3>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                            <div className="col-sm-9 col-lg-10 controls">
                                <DatePicker
                                    selected={startDate}
                                    onChange={handleStartDateChange}
                                    selectsStart
                                    startDate={startDate}
                                    endDate={endDate}
                                    placeholderText={'Please select From date'}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                />

                            </div>
                            <div className="col-sm-9 col-lg-10 controls">
                                <DatePicker
                                    selected={endDate}
                                    onChange={handleEndDateChange}
                                    selectsEnd
                                    startDate={startDate}
                                    endDate={endDate}
                                    minDate={startDate}
                                    maxDate={today}
                                    placeholderText={'Please select To date'}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {pharmviewData.length > 0 ? (
                    <div style={{height: '100%', width: '100%'}} className="mt-4">
                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={pharmviewData}
                            columns={columns}
                            pageSize={10}
                            slots={{
                                toolbar: GridToolbar,
                            }}
                            autoHeight
                            initialState={{
                                sorting: {
                                    sortModel: [{field: 'id', sort: 'desc'}],
                                },
                            }}
                        />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </section>
    );
}
export default GrnList;
